import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import KOSHA_TEMP_01 from './KOSHA_TEMP_01';
import Global from '../../../Services/Common/Global';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';

/** SyncAll·일괄 배치 등 장시간 POST (기존 15분 → 60분) */
const LONG_TIMEOUT_MS = 3600000;

function KOSHA_TEMP_01F() {
  const dispatch = useDispatch();
  const [syncDetailAllLoading, setSyncDetailAllLoading] = useState(false);
  const [syncAllRiskLibraryOnlyLoading, setSyncAllRiskLibraryOnlyLoading] =
    useState(false);
  const [fetchIndustryLoading, setFetchIndustryLoading] = useState(false);

  const GetResponseItemCount = (response) => {
    if (!response) return 0;
    const arr =
      response.items ?? response.Items ?? response.data ?? response.Data;
    if (Array.isArray(arr)) return arr.length;
    if (response.item ?? response.Item ?? response.result ?? response.Result) {
      return 1;
    }
    return 0;
  };

  /** 공단 prepare 업종 팝업 API — POST FetchKoshaIndustryCodes */
  const FetchKoshaIndustryCodes = async () => {
    setFetchIndustryLoading(true);
    try {
      const response = await apiRequest(
        'post',
        Global.urls.External.fetchKoshaIndustryCodes,
        {},
        { timeout: 120000 }
      );
      const n = response?.count ?? GetResponseItemCount(response);
      const ins = response?.insertedCount ?? response?.InsertedCount;
      const dbPart = ins != null ? ` · DB INSERT ${ins}건` : '';
      dispatch(
        showSnackbar({
          message: `업종 목록 조회 완료 (${n}건)${dbPart}`,
          type: 'success',
        })
      );
    } catch (e) {
      dispatch(
        showSnackbar({
          message:
            e?.response?.data?.message ||
            e?.message ||
            '업종 목록 조회에 실패했습니다. (FetchKoshaIndustryCodes)',
          type: 'error',
        })
      );
    } finally {
      setFetchIndustryLoading(false);
    }
  };

  const PostBatch = async ({
    urlKey,
    setBusy,
    confirmMsg,
    successFallback,
    errHint,
  }) => {
    if (!window.confirm(confirmMsg)) return;
    setBusy(true);
    try {
      const response = await apiRequest(
        'post',
        Global.urls.External[urlKey],
        {},
        { timeout: LONG_TIMEOUT_MS }
      );
      const msg = response?.message || response?.Message || successFallback;
      dispatch(showSnackbar({ message: msg, type: 'success' }));
    } catch (e) {
      dispatch(
        showSnackbar({
          message:
            e?.response?.data?.message ||
            e?.response?.data?.Message ||
            e?.message ||
            errHint,
          type: 'error',
        })
      );
    } finally {
      setBusy(false);
    }
  };

  const SyncAllRiskDetail = () =>
    PostBatch({
      urlKey: 'syncAllRiskDetail',
      setBusy: setSyncDetailAllLoading,
      confirmMsg:
        '공정 상세를 전체 일괄 동기화하시겠습니까? 시간이 오래 걸릴 수 있습니다.',
      successFallback: '상세 일괄 동기화가 완료되었습니다.',
      errHint: '상세 일괄 동기화에 실패했습니다. (syncAllRiskDetail)',
    });

  /** DB 업종 전체 — 공정 라이브러리만, koshaCd/indCd 입력 불필요 */
  const SyncAllRiskLibraryOnly = async () => {
    if (
      !window.confirm(
        'TB_BS_INDUSTRY_CODE에 등록된 모든 업종에 대해 공단 공정 목록만 가져와 라이브러리 테이블에 넣습니다. (위험 상세·등급·조치 없음 · 수백 건이면 매우 오래 걸릴 수 있습니다.) 계속하시겠습니까?'
      )
    ) {
      return;
    }

    setSyncAllRiskLibraryOnlyLoading(true);
    try {
      const response = await apiRequest(
        'post',
        Global.urls.External.syncAllRiskLibraryOnly,
        {},
        { timeout: LONG_TIMEOUT_MS }
      );
      const msg =
        response?.message ||
        response?.Message ||
        '전 업종 공정 라이브러리 동기화가 완료되었습니다.';
      const snackType =
        response?.success === true
          ? 'success'
          : response?.isPartialSuccess
            ? 'warning'
            : 'error';
      dispatch(showSnackbar({ message: msg, type: snackType }));
    } catch (e) {
      dispatch(
        showSnackbar({
          message:
            e?.response?.data?.message ||
            e?.response?.data?.Message ||
            e?.message ||
            '전 업종 라이브러리 동기화에 실패했습니다. (SyncAllRiskLibraryOnly)',
          type: 'error',
        })
      );
    } finally {
      setSyncAllRiskLibraryOnlyLoading(false);
    }
  };

  return (
    <KOSHA_TEMP_01
      syncDetailAllLoading={syncDetailAllLoading}
      syncAllRiskLibraryOnlyLoading={syncAllRiskLibraryOnlyLoading}
      fetchIndustryLoading={fetchIndustryLoading}
      FetchKoshaIndustryCodes={FetchKoshaIndustryCodes}
      SyncAllRiskDetail={SyncAllRiskDetail}
      SyncAllRiskLibraryOnly={SyncAllRiskLibraryOnly}
    />
  );
}

export default KOSHA_TEMP_01F;
